/* ════ LANE PACKING ════════════════════════════════════════ */
import { startHalf, endHalf } from './util.js';

// Greedily pack non-overlapping tasks into horizontal lanes. Overlap is tested
// in half-day units so AM/PM tasks on the same day pack correctly and adjacent
// (touching) tasks do not collide.
export function computeLanes(rt) {
  const s = [...rt].sort((a, b) => a.start.localeCompare(b.start) || startHalf(a) - startHalf(b)), lanes = [];
  s.forEach(t => {
    const si = startHalf(t), ei = endHalf(t); let ok = false;
    for (const l of lanes) {
      if (!l.some(x => { const xs = startHalf(x), xe = endHalf(x); return si < xe && ei > xs; })) { l.push(t); ok = true; break; }
    }
    if (!ok) lanes.push([t]);
  });
  return lanes;
}
